import React, { useContext, useRef, useState, useEffect } from "react";
import Input from "../components/Input/input";
import Container from "../components/Container";
import Title from "../components/Title";
// import Button from "../components/Button";
import Image from "../components/Image";
import loginImage from "../assets/images/login.png";
import { Login } from "../service/auth";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import { Context } from "./../contexts/Store";
import openEye from "../assets/images/eye-open.svg";
import closedeye from "../assets/images/eye-close.svg";
import logo from "./../assets/images/logo.png"
// import { GoogleReCaptchaProvider, useGoogleReCaptcha } from 'react-google-recaptcha-v3';

function LoginPage() {
    const navigate = useNavigate();
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [passwordVisible, setPasswordVisible] = useState(false);
    const [isError, setError] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const { dispatch } = useContext(Context);
    // const [recaptchaLoaded, setRecaptchaLoaded] = useState(false);
    
    // Function to handle reCAPTCHA verification
    // const handleRecaptchaVerify = async () => {
    //     if (!window.grecaptcha) {
    //         console.error("reCAPTCHA not loaded yet");
    //         return null;
    //     }
        
    //     try {
    //         return await new Promise((resolve) => {
    //             window.grecaptcha.ready(() => {
    //                 window.grecaptcha
    //                     .execute('6LeyCksrAAAAACJ4Srm9IFyp1mVs3coYHU6pbMXe', { action: 'login' })
    //                     .then(token => {
    //                         resolve(token);
    //                     })
    //                     .catch(error => {
    //                         console.error("reCAPTCHA error:", error);
    //                         resolve(null);
    //                     });
    //             });
    //         });
    //     } catch (error) {
    //         console.error("Error executing reCAPTCHA:", error);
    //         return null;
    //     }
    // };
    
    // Load reCAPTCHA script only on this page
    // useEffect(() => {
    //     const loadRecaptchaScript = () => {
    //         // Check if script is already loaded
    //         if (document.querySelector('script[src*="recaptcha/api.js"]')) {
    //             setRecaptchaLoaded(true);
    //             return;
    //         }
            
    //         const script = document.createElement("script");
    //         script.src = "https://www.google.com/recaptcha/api.js?render=6LeyCksrAAAAACJ4Srm9IFyp1mVs3coYHU6pbMXe";
    //         script.async = true;
    //         script.defer = true;
    //         script.onload = () => setRecaptchaLoaded(true);
    //         document.head.appendChild(script);
    //     };
        
    //     loadRecaptchaScript();
        
    //     // Cleanup function to remove script when component unmounts
    //     return () => {
    //         // We don't remove the script on unmount to avoid issues with navigation
    //         // If you want to remove it, uncomment the code below
    //         /*
    //         const recaptchaScript = document.querySelector('script[src*="recaptcha/api.js"]');
    //         if (recaptchaScript) {
    //             document.head.removeChild(recaptchaScript);
    //         }
    //         */
    //     };
    // }, []);

    const togglePassword = () => {
        setPasswordVisible(!passwordVisible);
    };

    const handleSubmit = async () => {
        // Get reCAPTCHA token
        // const token = await handleRecaptchaVerify();
        
        // Send login request without reCAPTCHA token
        const response = await Login({ 
            username, 
            password,
            // recaptcha_token: token 
        });
        
        if (response.userrole) {
            if (response.userrole == "superuser" || response.userrole == "lms_admin") {
                navigate("/superadmin/");
            }
            if (response.userrole == "campus_admin") {
                navigate("/campus-admin/");
            }
            if (response.userrole == "lead_manager") {
                navigate("/salesmanager/");
            }
            if (response.userrole == "lead_generator") {
                navigate("/leadgenerator/");
            }
            if (response.userrole == "sales_person") {
                navigate("/admission-consultant/");
            }
            if (response.userrole == "sales_team_leader") {
                navigate("/team-leader/");
            }
            if (response.userrole == "finance_executive") {
                navigate("/finance-executive/");
            }
            if (response.userrole == "finance_manager") {
                navigate("/finance-manager/");
            }

            const user_details = {
                is_verified: true,
                access_token: response.access,
                role: response.userrole,
            };
            
            if (
                response.userrole == "superuser" ||
                response.userrole == "lms_admin" ||
                response.userrole == "campus_admin" ||
                response.userrole == "lead_manager" ||
                response.userrole == "lead_generator" ||
                response.userrole == "sales_person" ||
                response.userrole == "sales_team_leader" ||
                response.userrole == "finance_executive" ||
                response.userrole == "finance_manager"
            ) {
                dispatch({
                    type: "UPDATE_USER_DETAILS",
                    user_details,
                });
            } else {
                setError(true);
                setErrorMessage(
                    "Username and Password does not belongs to this dashboard"
                );
            }
        } else {
            setError(true);
            setErrorMessage(response.detail);
        }
    };

    const handleEnter = (event) => {
        if (event.key.toLowerCase() === "enter") {
            const form = event.target.form;
            const index = [...form].indexOf(event.target);
            form.elements[index + 1].focus();
            event.preventDefault();
        }
    };

    return (
        <>
            <MainContainer>
                <Oval src={require("./../assets/images/Oval.svg").default} />
                <ArrowTop
                    src={require("./../assets/images/Shape.svg").default}
                />
                <ArrowBottom
                    src={require("./../assets/images/Shape.svg").default}
                />
                <FormDiv>
                    <SubDiv>
                        <LogoDiv>
                            <Logo
                                src={logo}
                            />
                        </LogoDiv>
                        <LoginForm>
                            <InputField>
                                <Heading>Username</Heading>
                            </InputField>
                            <UserName
                                onChange={(value) => {
                                    setUsername(value.target.value);
                                    setError(false);
                                }}
                                onKeyDown={handleEnter}
                                autoFocus
                            />
                        </LoginForm>
                        <LoginForm>
                            <InputField style={{ marginTop: "20px" }}>
                                <Heading>Password</Heading>
                            </InputField>
                            <PasswordInputDiv>
                                <UserNName
                                    type={passwordVisible ? "text" : "password"}
                                    onChange={(value) => {
                                        setPassword(value.target.value);
                                        setError(false);
                                    }}
                                    onKeyDown={(e) => {
                                        if (e.key.toLowerCase() === "enter") {
                                            e.preventDefault();
                                            if (username === "" && password === "") {
                                                setError(true);
                                                setErrorMessage(
                                                    "Enter username and password"
                                                );
                                            }
                                            else if (username === "") {
                                                setError(true);
                                                setErrorMessage(
                                                    "Enter username"
                                                );
                                            } else if (password === "") {
                                                setError(true);
                                                setErrorMessage(
                                                    "Enter password"
                                                );
                                            } else {
                                                handleSubmit();
                                            }
                                        }
                                    }}
                                />
                                <EyeImage
                                    onClick={() => {
                                        togglePassword();
                                    }}
                                    src={passwordVisible ? openEye : closedeye}
                                />
                            </PasswordInputDiv>
                        </LoginForm>
                        <ErrorDiv>
                            {isError && <Text>{errorMessage}</Text>}
                        </ErrorDiv>

                        <Button
                            onClick={() => {
                                if (username === "" && password === "") {
                                    setError(true);
                                    setErrorMessage("Enter username and password");
                                }
                                else if (username === "") {
                                    setError(true);
                                    setErrorMessage("Enter username");
                                } else if (password === "") {
                                    setError(true);
                                    setErrorMessage("Enter password");
                                } else {
                                    handleSubmit();
                                }
                            }}
                        >
                            Sign In
                        </Button>
                    </SubDiv>
                </FormDiv>
            </MainContainer>
        </>
    );
};

const MainContainer = styled.div`
    background: #522f91;
    height: 100vh;
    width: 100%;
    position: relative;
    overflow: hidden;
`;
const Oval = styled.img`
    position: absolute;
    left: 0px;
    height: 50vh;
`;
const ArrowBottom = styled.img`
    position: absolute;
    right: 0px;
    bottom: -100px;
    height: 300px;
    width: 30%;
`;
const ArrowTop = styled.img`
    position: absolute;
    right: 0px;
    bottom: 50px;
    height: 300px;
    width: 30%;
`;
const FormDiv = styled.form`
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    flex-direction: column;
`;
const SubDiv = styled.div`
    width: 25%;
    z-index: 100;
    @media (max-width: 980px) {
        width: 30%;
    }
    @media (max-width: 780px) {
        width: 35%;
    }
`;
const LogoDiv = styled.div`
    display: flex;
    justify-content: center;
    margin-bottom: 60px;
`;
const Logo = styled.img`
    height: 74px;
    width: 218px;
`;
const LoginForm = styled.div`
    width: 100%;
    display: flex;
    justify-content: center;
    flex-direction: column;
`;
const InputField = styled.div`
    margin-bottom: 8px;
`;
const Heading = styled.h4`
    color: #fff;
    font-size: 15px;
    font-family: "Inter";
    font-weight: 500;
`;
const UserName = styled.input`
    background: #6c4b9d;
    height: 60px;
    outline: none;
    border: 1px solid #6c4b9d;
    border-radius: 5px;
    font-size: 15px;
    color: #fff;
    padding: 0 15px;

    &:focus {
        border: 1px solid #c2c2c2;
    }
`;
const UserNName = styled.input`
    background: #6c4b9d;
    height: 60px;
    outline: none;
    border: 1px solid #6c4b9d;
    border-radius: 5px;
    font-size: 15px;
    color: #fff;
    padding: 0 15px;
    width: 100%;

    &:focus {
        border: 1px solid #c2c2c2;
    }
`;

const PasswordField = styled.div`
    position: relative;
    display: flex;
    justify-content: space-between;
    width: 100%;
`;
const PasswordInputDiv = styled.div`
    position: relative;
    width: 100%;
    display: flex; ;
`;
const EyeImage = styled.img`
    cursor: pointer;
    position: absolute;
    right: 5%;
    bottom: 35%;
`;
const ErrorDiv = styled.div`
    height: 30px;
    margin-top: 10px;
`;
const Button = styled.div`
    background: #fff;
    height: 60px;
    outline: none;
    border-radius: 5px;
    font-size: 15px;
    color: #522f91;
    padding: 0 15px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 700;
    margin-top: 20px;
    cursor: pointer;
`;
const Text = styled.h4`
    color: #ff3333;
`;
export default LoginPage;